import * as React from 'react'
import Language from "./Language"
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AdbIcon from '@mui/icons-material/Adb';
import MenuTitled from "./MenuTitled"
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Identity from './Identity';


export default function Manager({useStyle, useLanguages}) {
    const [style, setStyle] = useStyle
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [activeController, setActiveController] = React.useState(null);

    const submenus = [
        {
            name: "Language",
            key: "profile",
            menu: function() {
                return <Language 
                        key="Languages"
                        useLanguages={useLanguages}
                        useEvents={{
                            onMouseOver: (e) => handleOver(e, this),
                            onMouseOut: (e) => handleOut(e, this)
                        }}
                    />
            },
            component: <>ok 1</>
        },
        {
            name: 'Identity',
            key: "identity",
            menu: MenuTitled,
            component: <Identity />
        },
        {
            name: 'Skills',
            key: "skills",
            menu: MenuTitled,
            component: <>ok 3</>
        }
    ]

    const handleOpen = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorElNav(null)
        setStyle()
    }

    const handleClick = (event, menu) => {
        debugger
        handleClose(event, menu)
        setActiveController(menu)
    }

    const handleOut = (even, menu) => {
        let element = event.currentTarget
        setStyle()
    }

    const handleOver = (event, menu) => {
        let element = event.currentTarget
        let happen = {}
        
        happen[menu.key] = {
            ...style[menu.key],
            ...{
                background: "rgba(125,125,125, 0.25)"
            }
        }

        setStyle(happen)
    }

    return (
        <div className="controller">
            <div>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    onClick={handleOpen}
                >
                    <MenuIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={ handleClose }
                >
                    {submenus.map((menu) => {
                            if (!menu.menu) {
                                return (
                                    <MenuItem 
                                        key={menu.name} 
                                        disabled
                                    >
                                        <Typography>{menu.name}</Typography>
                                    </MenuItem>
                                )
                            }

                            return menu.menu({
                                menu: menu,
                                style: style,
                                setStyle: setStyle,
                                handleClose: handleClose,
                                setActiveController: setActiveController
                            })
                        }
                    )}
                </Menu>
            </div>
            <div>
                { activeController ? activeController.component : <></>}
            </div>
        </div>
    )
}